import { styled } from '@obvio/app'
import { Section } from '@obvio/ui'

export const TextSection = styled(Section)`
  text-align: center;
  h2 {
    margin-top: ${(theme) => theme.spacing.medium} !important;
  }
`
